// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3H_22","errorLogs":"styles_errorLogs__1DtgQ"};